import { makeAutoObservable } from 'mobx';
import { IRollupStore } from './types';

export class RollupStore implements IRollupStore {
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading(loading: boolean) {
    this.isLoading = loading;
  }
}
